((homepageProductsCarousel, $) => {
  'use strict';

  const $dom = {};

  const cacheDom = () => {
    $dom.homeProductsCarousel = $('.js-home-products-carousel--products-list-slider');
  };

  const bindUIActions = () => {
    $dom.homeProductsCarousel.slick({
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 4,
      arrow: true,
      responsive: [
        {
          breakpoint: 801,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    });
  };

  const init = () => {
    cacheDom();
    bindUIActions();
  };

  homepageProductsCarousel.init = init;

})(window.homepageProductsCarousel = window.homepageProductsCarousel || {}, jQuery);
